var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgShareOrange = function SvgShareOrange(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "54px",
    viewBox: "0 0 49 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fill: "#CE410D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8333,38.1687 C38.7644,38.1687 36.9133,38.9819 35.4978,40.256 L16.0883,29.006 C16.2244,28.3825 16.3333,27.759 16.3333,27.1084 C16.3333,26.4578 16.2244,25.8343 16.0883,25.2108 L35.28,14.0693 C36.75,15.4247 38.6828,16.2651 40.8333,16.2651 C45.3522,16.2651 49,12.6325 49,8.13253 C49,3.63253 45.3522,0 40.8333,0 C36.3144,0 32.6667,3.63253 32.6667,8.13253 C32.6667,8.78313 32.7756,9.40663 32.9117,10.0301 L13.72,21.1717 C12.25,19.8163 10.3172,18.9759 8.16667,18.9759 C3.64778,18.9759 0,22.6084 0,27.1084 C0,31.6084 3.64778,35.241 8.16667,35.241 C10.3172,35.241 12.25,34.4006 13.72,33.0452 L33.1022,44.3223 C32.9661,44.8916 32.8844,45.4879 32.8844,46.0843 C32.8844,50.4488 36.4506,54 40.8333,54 C45.2161,54 48.7822,50.4488 48.7822,46.0843 C48.7822,41.7199 45.2161,38.1687 40.8333,38.1687 Z",
    id: "Path"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgShareOrange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share-orange.5a276b3c90e662a396169334a49352d8.svg";